import { render, staticRenderFns } from "./ChangeDatasourceSridDialog.vue?vue&type=template&id=10ce0b2f&"
import script from "./ChangeDatasourceSridDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeDatasourceSridDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports